import { AlertBannerType } from '@/lib/mx-asurion-ui-react';
import { createContext, ReactNode } from 'react';

export type Alert = { message: ReactNode; type: AlertBannerType };

export type AlertContext = {
  alert: Alert;
  setAlert: (alert: Alert) => void;
};

export const AlertContext = createContext<AlertContext>({
  alert: { message: null, type: 'default' },
  setAlert: () => {},
});
